'use client';

import {
  useSession,
  // signIn,
  signOut,
  // ClientSafeProvider,
  // getProviders,
} from 'next-auth/react';
import { useEffect } from 'react';

type GoogleAuthButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  callback?: (data: any) => void;
  template?: string;
};

export default function GoogleAuthButton(props: GoogleAuthButtonProps) {
  const { data: session } = useSession();

  // const [providers, setProviders] = useState<Record<
  //   string,
  //   ClientSafeProvider
  // > | null>(null);

  const popupCenter = (url: string, title: string) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX;
    const dualScreenTop = window.screenTop ?? window.screenY;

    const width =
      window.innerWidth ?? document.documentElement.clientWidth ?? screen.width;

    const height =
      window.innerHeight ??
      document.documentElement.clientHeight ??
      screen.height;

    const systemZoom = width / window.screen.availWidth;

    const left = (width - 500) / 2 / systemZoom + dualScreenLeft;
    const top = (height - 550) / 2 / systemZoom + dualScreenTop;

    const newWindow = window.open(
      url,
      title,
      `width=${500 / systemZoom},height=${
        550 / systemZoom
      },top=${top},left=${left}`,
    );

    newWindow?.focus();
  };

  // useEffect(() => {
  //   const fetchProviders = async () => {
  //     const providersData = await getProviders();
  //     setProviders(providersData);
  //   };

  //   fetchProviders();
  // }, []);

  useEffect(() => {
    props.callback && props.callback(session);
  }, [session]);

  useEffect(() => {
    if (
      props.template &&
      session?.user?.email &&
      !session?.user?.email.endsWith(props.template)
    ) {
      signOut();
    }
  }, [session, props.template]);

  if (session)
    return (
      <button
        {...props}
        onClick={() => {
          signOut();
        }}
      >
        Sign out {session.user?.name}
      </button>
    );

  return (
    <button
      {...props}
      onClick={() => {
        popupCenter('/auth/google', 'Google SignIN');
        // signIn(provider.id);
      }}
    >
      {props.children || `Sign in with Google`}
    </button>
  );
}
